package fr.frux.shared.data.local

import kotlin.math.PI
import kotlin.math.cos

/** Boîte englobante d'un rayon, partagée par les caches arbres et lieux. */
internal data class CacheBounds(
    val latMin: Double,
    val latMax: Double,
    val lngMin: Double,
    val lngMax: Double,
) {
    companion object {
        /** Un degré de latitude ≈ 111.32 km ; sert aussi de base à la largeur en longitude. */
        private const val KM_PER_DEGREE = 111.32
        private const val MIN_COS_LAT = 0.01

        fun around(
            lat: Double,
            lon: Double,
            radiusKm: Double,
        ): CacheBounds {
            val dLat = radiusKm / KM_PER_DEGREE
            // Aux hautes latitudes cos(lat) tend vers 0 : la borne évite une division par zéro en
            // dégénérant vers une boîte très large, le haversine fait le tri derrière.
            val dLon = radiusKm / (KM_PER_DEGREE * cos(lat * PI / 180).coerceAtLeast(MIN_COS_LAT))
            return CacheBounds(lat - dLat, lat + dLat, lon - dLon, lon + dLon)
        }
    }
}
